import type { TSliceReducer } from 'core/store';
import { initialState } from './shortcuts.constants';
import type { IShortcutsState } from './shortcuts.types';

const updateShortcutsListQuery: TSliceReducer<IShortcutsState, { query: string }> = (state, action) => {
  state.filters.query = action.payload.query;
};

const updateShortcutsListPage: TSliceReducer<IShortcutsState, { page: number }> = (state, action) => {
  state.shortcutListPagination.currentPage = action.payload.page;
};

const updateShortcutsFiltersPriceGroupIds: TSliceReducer<IShortcutsState, { priceGroupIds: Array<string> }> = (
  state,
  action,
) => {
  state.filters.segmentFiltersSelected.priceGroupIds = action.payload.priceGroupIds;
};

const updateShortcutsFiltersPriceListIds: TSliceReducer<IShortcutsState, { priceListIds: Array<string> }> = (
  state,
  action,
) => {
  state.filters.segmentFiltersSelected.priceListIds = action.payload.priceListIds;
};

const resetShortcutForm: TSliceReducer<IShortcutsState> = state => {
  state.form = initialState.form;
};

const resetDeleteConfirmation: TSliceReducer<IShortcutsState> = state => {
  state.deleteConfirmation = initialState.deleteConfirmation;
};

const resetShortcutListPagination: TSliceReducer<IShortcutsState> = state => {
  state.shortcutListPagination = initialState.shortcutListPagination;
};

export const reducers = {
  updateShortcutsListQuery,
  updateShortcutsListPage,
  updateShortcutsFiltersPriceGroupIds,
  updateShortcutsFiltersPriceListIds,
  resetShortcutForm,
  resetDeleteConfirmation,
  resetShortcutListPagination,
};
